/**
 * Het scherm van de beheerder: zes tabbladen, elk een eigen bestand in
 * tabs/. Dit bestand is alleen de kop en de tabbladmachine; een tabblad
 * haalt zelf op wat het nodig heeft zodra het opent, en raakt zijn staat
 * kwijt zodra je naar een ander tabblad gaat.
 */
import React, { useState } from 'react';
import { Users, MessageSquare, Sliders, LogOut, FileText } from 'lucide-react';
import { maakApi } from '../../api/client';
import { maakBeheerApi } from '../../api/beheer';
import { basis } from './stijlen';
import { Stellingen } from './tabs/Stellingen';
import { Personas } from './tabs/Personas';
import { AgentRollen } from './tabs/AgentRollen';
import { Prompts } from './tabs/Prompts';
import { Beheerders } from './tabs/Beheerders';
import { Logboek } from './tabs/Logboek';

const TABS = [
  ['stellingen', 'Stellingen', MessageSquare],
  ['personas', "Persona's", Users],
  ['agentrollen', 'Agent-rollen', Sliders],
  ['prompts', 'Prompts', MessageSquare],
  ['beheerders', 'Beheerders', Users],
  ['logs', 'Logbestanden', FileText],
];

function BeheerPaneel({ user, token, onLogout, apiUrl }) {
  const [tab, setTab] = useState('stellingen');
  const { verzoek } = maakApi({ apiUrl, token, bijVerlopenToken: onLogout });
  const api = maakBeheerApi(verzoek);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <img src="/socrates_logo.png" alt="Socrates" style={{ height: '125px' }} />
        <div style={styles.userInfo}>
          <span>{user.naam}</span>
          <button onClick={onLogout} style={styles.logoutBtn}><LogOut size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />Uitloggen</button>
        </div>
      </div>

      <div style={styles.tabs}>
        {TABS.map(([sleutel, naam, Icoon]) => (
          <button key={sleutel} style={tab === sleutel ? styles.tabActive : styles.tab} onClick={() => setTab(sleutel)}>
            <Icoon size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />{naam}
          </button>
        ))}
      </div>

      <div style={styles.content}>
        {tab === 'stellingen' && <Stellingen api={api} user={user} />}
        {tab === 'personas' && <Personas api={api} apiUrl={apiUrl} />}
        {tab === 'agentrollen' && <AgentRollen api={api} />}
        {tab === 'prompts' && <Prompts api={api} />}
        {tab === 'beheerders' && <Beheerders api={api} />}
        {tab === 'logs' && <Logboek api={api} />}
      </div>
    </div>
  );
}

const styles = {
  ...basis,
  header: { background: 'white', padding: '16px 48px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  userInfo: { display: 'flex', alignItems: 'center', gap: '16px' },
  tabs: { display: 'flex', background: 'white', borderBottom: '1px solid black', padding: '0 48px' },
  content: { padding: '24px 48px' },
};

export default BeheerPaneel;
